import axiosInstance from '@/app/api/axiosInstance';
import { HsnCode, HsnCodeCreate, HsnCodeUpdate } from '@/app/types/hsnCode';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';

export const listHsnCodes = async (params: ListQueryParams): Promise<PaginatedResponse<HsnCode>> => {
  try {
    const response = await axiosInstance.get<PaginatedResponse<HsnCode>>('/hsn-codes/', { 
      params 
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to list HSN codes:', error);
    throw error;
  }
};

export const getHsnCode = async (hsnCodeId: number): Promise<HsnCode> => {
  try {
    const response = await axiosInstance.get<HsnCode>(`/hsn-codes/${hsnCodeId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get HSN code with ID ${hsnCodeId}:`, error);
    throw error;
  }
};

export const createHsnCode = async (data: HsnCodeCreate): Promise<HsnCode> => {
  try {
    const response = await axiosInstance.post<HsnCode>('/hsn-codes/', data);
    return response.data;
  } catch (error) {
    console.error('Failed to create HSN code:', error);
    throw error;
  }
};

export const updateHsnCode = async (hsnCodeId: number, data: HsnCodeUpdate): Promise<HsnCode> => {
  try {
    const response = await axiosInstance.patch<HsnCode>(`/hsn-codes/${hsnCodeId}`, data);
    return response.data;
  } catch (error) {
    console.error(`Failed to update HSN code with ID ${hsnCodeId}:`, error);
    throw error;
  }
};

export const deleteHsnCode = async (hsnCodeId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/hsn-codes/${hsnCodeId}`);
  } catch (error) {
    console.error(`Failed to delete HSN code with ID ${hsnCodeId}:`, error);
    throw error;
  }
}; 